module.exports = __webpack_public_path__ + "static/img/bip7B1.b4477a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bip7B1.png
// module id = uCaQ
// module chunks = 73